import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../../../utils/page-title";

export const Route = createFileRoute("/admin/charts/$chartId")({
  ssr: false,
  head: ({ params }) => ({
    ...pageHead(`Admin Chart Review · ${params.chartId.slice(0, 8)}`, {
      canonicalPath: `/admin/charts/${params.chartId}`,
      robots: "noindex, nofollow",
    }),
  }),
});
